import lazySizes from 'lazysizes';

import Component from '../../components/component/component';
import Helpers, { debounce, DebouncedFunction } from '../../components/helpers/helpers';

import './tab-carousel.scss';

interface ITabCarouselSettings {
    carouselSelector: string;
    fixedClass: string;
    hasMovedClass: string;
    navListSelector: string;
    navSelector: string;
}

export default class TabCaorusel extends Component {
    static initSelector: string = '.tab-carousel';

    carousel: JQuery;
    debouncedScrollHandler: DebouncedFunction<() => void>;
    navigation: JQuery;
    navigationList: JQuery;
    settings: ITabCarouselSettings;

    constructor(target: HTMLElement) {
        super(target);

        this.settings = {
            carouselSelector: '.slider__carousel',
            fixedClass: 'is-fixed',
            hasMovedClass: 'has-moved',
            navListSelector: '.tabs__nav-list',
            navSelector: '.tabs__nav',
        };

        this.carousel = this.element.find(this.settings.carouselSelector);
        this.navigation = this.element.find(this.settings.navSelector);
        this.navigationList = this.element.find(this.settings.navListSelector);

        this.init();
    }

    init(): void {
        this.debouncedScrollHandler = debounce(this.onScroll.bind(this), 5);
        $(window).on('scroll resize', this.debouncedScrollHandler);
        $(window).on('scroll.lazyloadHandler', this.lazyloadHandler.bind(this));
    }

    get isFixed(): boolean {
        return this.navigationList.hasClass(this.settings.fixedClass);
    }

    onScroll(): void {
        if (window.matchMedia('(min-width: ' + Helpers.bp.md + 'px)').matches) {
            const windowTop: number = $(window).scrollTop();
            const navigationTop: number = this.navigation.offset().top;
            const carouselBottom: number = this.carousel.offset().top + this.carousel.height();

            let headerOffset: number = 0;

            if ($(document).find('.header').length > 0) {
                if (window.matchMedia('(min-width: ' + Helpers.bp.sm + 'px)').matches) {
                    headerOffset = 74;
                }
            }

            if (windowTop + headerOffset > navigationTop && !this.isFixed) {
                this.navigation.css({
                    height: this.navigationList.height(),
                });

                this.navigationList.css({
                    paddingTop: headerOffset,
                    position: 'fixed',
                    top: 0,
                }).addClass(this.settings.fixedClass).addClass(this.settings.hasMovedClass);
            } else if (windowTop + headerOffset < navigationTop && this.isFixed) {
                this.navigation.removeAttr('style');
                this.navigationList.removeAttr('style').removeClass(this.settings.fixedClass).removeClass(this.settings.hasMovedClass);
            }

            if (windowTop + headerOffset > carouselBottom - this.navigationList.height()) {
                this.navigationList.css({
                    left: 0,
                    position: 'absolute',
                    right: 0,
                    top: this.carousel.height() - headerOffset,
                }).removeClass(this.settings.fixedClass);
            }
        } else {
            this.navigationList.removeAttr('style');
            this.navigation.removeAttr('style');
        }
    }

    lazyloadHandler(): void {
        const tabsElement: JQuery = this.element.find('.tab-carousel__tabs');

        if (tabsElement.hasClass('is-in-viewport')) {
            const imgElement: JQuery = tabsElement.find('.slick-slide.slick-current .image__img.lazyloading');

            imgElement.removeClass('lazyloading').removeClass('lazyload');
            lazySizes.loader.unveil(imgElement[0]);

            $(window).off('scroll.lazyloadHandler');
        }
    }
}
